import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface OnePageCheckExistingUser extends ApiParameter {
    email: string;
    currentDateTime: string;
}

export interface ExistingUserCheckModel {
    isSuccess: boolean;
    isDataFound?: boolean;
    message: string;
}

const customApiUrl = "/api/v2/UserLookup/UserCheck";

export function checkExistingUser(parameter: OnePageCheckExistingUser) {
    return get<ExistingUserCheckModel>(`${customApiUrl}`, parameter);
}
